import { Params } from '@angular/router';
import { IFilter } from '@epicuro-next/ataraxia/models';
import { ORDER_BOOK_SEARCH_URL_PARAM } from '@epicuro-next/constants/features/order-book';

export function generateQueryParamsOnFilterUpdate(
  oldParams: Params,
  filters: IFilter[],
  search: string | null,
) {
  const newParams = filters.reduce(
    (res: Params, { fieldId, value }) => ({
      ...res,
      [fieldId]: [value].concat(res[fieldId] ?? []),
    }),
    { [ORDER_BOOK_SEARCH_URL_PARAM]: search || null },
  );

  return Object.entries({
    ...oldParams,
    ...newParams,
  }).reduce(
    (params: Params, [param]) => ({
      ...params,
      [param]: newParams[param] ?? null,
    }),
    {},
  );
}
